import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Startup } from './startups.model';
import { take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-voting',
  templateUrl: './voting.component.html',
  styleUrls: ['./voting.component.scss']
})
export class VotingComponent implements OnInit {

  startups: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.startups = this.afs.collection('startups', (ref) => {
      return ref.orderBy('order')
    }).valueChanges().pipe(
      take(1)
    )
  }

  vote(sid) {
    this.afs.collection('startups').doc(sid).get().pipe(
      take(1)
    ).subscribe((doc: any) => {
      const startup = doc.data();
      const votes = startup.votes + 1;
      this.afs.collection('startups').doc(sid).update({
        votes
      }).then(() => {
        this.auth.getUser().then((user) => {
          this.afs.collection('users').doc(user.uid).update({
            voted: true
          }).then(() => {
            this.startups = this.afs.collection('startups', (ref) => {
              return ref.orderBy('order')
            }).valueChanges();
          })
        })
      })
    })
  }

}
